import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import apiBaseline from './apiBaseline.mjs'

export default ({
    isDesc,
    pblProgress,
    pblStsCodes,
    pblType,
    prjId,
    prjPatternId,
}) => {
    return useSwrNoCache(
        () => apiBaseline.readList({
            isDesc,
            pblProgress,
            prjPatternId,
            pblStsCodes,
            pblType,
            prjId,
        }),

        {
            dependencies: [
                isDesc,
                pblProgress,
                prjPatternId,
                pblStsCodes,
                pblType,
                prjId,
            ]
        },
    )
}
